import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const routeIsErrorPage = (regExp: RegExp = /\/404$/i) => createSelector(getCurrentRoute, (route) => (route === null ? null : route.url.match(regExp) !== null));
